import { render } from "./UpdateCampaignModal.vue?vue&type=template&id=e33e2e3c&scoped=true"
import script from "./UpdateCampaignModal.vue?vue&type=script&lang=js"
export * from "./UpdateCampaignModal.vue?vue&type=script&lang=js"

import "./UpdateCampaignModal.vue?vue&type=style&index=0&id=e33e2e3c&lang=scss&scoped=true"

import exportComponent from "/builds/retina-v5/principal-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e33e2e3c"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QCard,QCardSection,QSeparator});
